//
//
//
//
//
//
//
//
//
//
//
//
//

import PhoneMask from './phoneMask'
export default {
  name: "phone-header",
  components: {
    PhoneMask
  },
  data () {
    return {
      isOpen: true
    }
  },
  methods: {
    handleToHome () {
      this.$router.push({name: 'home'})
    },
    handleOpen () {
      this.$emit('handleGetOpen',this.isOpen)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/phoneHeader.vue